import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "terracycle-intro" }
const _hoisted_2 = { class: "main container" }
const _hoisted_3 = { class: "about-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "about-title-1" }, " Corporate Introduction ", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-lg-6\"><h3 class=\"about-title-2\"> Our Mission </h3><div class=\"about-desc\"> Eliminate the Idea of Waste </div><h3 class=\"about-title-2 margin-top\"> Our Story </h3><div class=\"about-desc\"> TerraCycle operates a variety of recycling programs with various brands (company) that care about the environment. <br><br> We provide a variety of solutions to preserve a sustainable environment with the goal of &quot;recycling non-recyclable products(packaging).“ </div></div>", 1)
const _hoisted_7 = { class: "col-12 col-lg-6" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><h3 class=\"about-title-2\"> Our Role &amp; Responsibility </h3><div class=\"about-desc\"> We will build a recycling platform so that each material can be collected and processed. <br> Analyzes products(material) that need to be recycled. <br> Manage and supervise recycling processes. <br> R&amp;D together so that more diverse products (packaging materials) can be recycled. <br><br> If you are curious about more diverse activities of TerraCycle around the world, please click the link below. </div></div><div class=\"row\"><a class=\"jump-btn\" href=\"#\"> Learn more about TerraCycle </a></div>", 2)

import Images from '../images';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_AppBanner = _resolveComponent("AppBanner")!
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBanner, {
      title: "TerraCycle Intro",
      desc: "Small actions can gather and make a big difference. All resources can be recycled, We can all be together for valuable things, Experience the real recycle that TerraCycle creates.",
      image: _unref(Images).About.bannerTc
    }, null, 8, ["image"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppBreadcurmb, { routes: [{name: 'Home', to: {name: 'home'}}, {name: 'TerraCycle Intro', to: {name: 'about_1'}}] }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: _unref(Images).About.bannerTcIntro,
              class: "banner"
            }, null, 8, _hoisted_8)
          ])
        ]),
        _hoisted_9
      ])
    ])
  ]))
}
}

})